export const getProductImageSrc = (imagePath: string): string => {
	if (!imagePath) return '/images/placeholder.png';
	// Absolute URL
	if (/^https?:\/\//i.test(imagePath)) return imagePath;
	// If already starts with /images, keep as-is
	if (imagePath.startsWith('/images/')) return imagePath;
	// If starts with a known public folder (flip_images_*), prefix with /
	if (/^(flip_images_|images\/|banners\/)/.test(imagePath)) {
		return imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
	}
	// Default: app expects under /images when old data used relative names
	return `/images/${imagePath}`;
};
